import { Flex, Space, Text } from '@billy/design-system'
import { PropsWithChildren, ReactElement, ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

import * as Styled from './styles'

interface StepContainerProps extends PropsWithChildren {
  image: ReactNode
  title: string
}

export const StepContainer = ({ children, image, title }: StepContainerProps): ReactElement => {
  const { t } = useTranslation()

  return (
    <Flex flexDirection="column">
      <Flex justifyContent="center">
        <Styled.StepContainerImageWrapper>{image}</Styled.StepContainerImageWrapper>
      </Flex>
      <Space size="s8" />
      <Text colorVariant="disable" uppercase variant="bodySM">
        {t('onboarding.steps.main_title')}
      </Text>
      <Space size="s4" />
      <Text variant="h2">{title}</Text>
      <Space size="s32" />
      {children}
    </Flex>
  )
}
